import a from "../../../assets/country/1.png";
import b from "../../../assets/country/2.png";
import c from "../../../assets/country/3.png";
import d from "../../../assets/country/4.png";
import f from "../../../assets/country/6.png";
import g from "../../../assets/country/7.png";
import h from "../../../assets/country/8.png";
import i from "../../../assets/country/9.png";
import j from "../../../assets/country/10.png";
import k from "../../../assets/country/11.png";
const Countries = () => {
  const images = [a, b, c, d, f, g, h, i, j, k];
  return (
    <div className="animate flex justify-around">
      {images.map((img, index) => (
        <img src={img} alt="" className="" key={index} />
      ))}
    </div>
  );
};

export default Countries;
